import type { Organization } from './organization';

export enum UserType {
    ADMIN = 'admin',
    DESIGNER = 'designer',
    MEMBER = 'member',
}

export interface User {
    id: number;
    firstName: string;
    lastName: string;
    email: string;
    type: UserType;
    profilePicture: string;
    organization: Organization;
}

export interface OrganizationUserResponse {
    count: number;
    next: string | null;
    previous: string | null;
    results: User[];
}
